import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  align?: "left" | "between";
}

export default function SectionHeading({
  kicker,
  title,
  description,
  actionLabel,
  actionTo,
  align = "between",
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-7 flex flex-col gap-4 md:mb-9 ${
        align === "between" && actionLabel ? "md:flex-row md:items-end md:justify-between" : ""
      }`}
    >
      <div>
        <p className="flex items-center gap-2 font-label text-[11px] font-semibold uppercase tracking-[0.22em] text-accent-700">
          <span className="h-[2px] w-5 bg-accent-500" />
          {kicker}
        </p>
        <h2 className="mt-2.5 font-heading text-[22px] font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-[13px] leading-relaxed text-foreground-600 md:text-sm">
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex w-fit shrink-0 cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-[12px] font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}